module.exports = __webpack_public_path__ + "static/media/fly0069.0ffbf96c.webp";